import ApplicationValidation from './apply';

/* jscpd:ignore-start */
const RegisterValidation = ApplicationValidation;

export default RegisterValidation;

/* jscpd:ignore-end */
